import { createApp } from 'vue'
import App from './App.vue'
import router from './router'; 
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '../src/assets/css/main.css'


const app = createApp(App)
app.use(ElementPlus)
app.use(router)
app.provide('api_url', 'https://api.z.6674.cn/blog/');
app.mount('#app')
